import React, { useRef, useEffect } from 'react'
import styles from './TabButton.module.scss'
import { NavLink, useLocation } from 'react-router-dom'
import classNames from 'classnames'

const TabButton = ({
  id,
  type,
  selected,
  label,
  handleClick,
  path,
  isScrollable = true,
  buttonClassname,
  activeButtonClassname,
  inactiveButtonClassname,
  buttonClass,
  tabIsActive = false,
  handleNavClick,
}) => {
  const activeLinkRef = useRef(null)
  const location = useLocation()

  const handleNavLinkClick = () => {
    if (handleNavClick) {
      handleNavClick()
    }
  }

  useEffect(() => {
    if (isScrollable && activeLinkRef.current) {
      const item = activeLinkRef.current
      const container = item.parentElement

      if (container) {
        const itemLeft = item.offsetLeft
        const itemWidth = item.offsetWidth
        const containerWidth = container.clientWidth
        const targetScrollLeft = itemLeft + itemWidth / 2 - containerWidth / 2
        container.scrollTo({
          left: targetScrollLeft,
          behavior: 'smooth',
        })
      }
    }
  }, [location, selected, isScrollable])
  return (
    <>
      {type === 'button' && (
        <button
          aria-label={label}
          className={classNames(
            id === selected ? styles['active'] : styles['inactive'],
            styles['tab-button'],
            buttonClass
          )}
          ref={id === selected ? activeLinkRef : null}
          onClick={() => handleClick(id)}
        >
          {label}
        </button>
      )}
      {type === 'link' && (
        <NavLink
          className={(props) => {
            return classNames(
              props.isActive || tabIsActive
                ? styles['active']
                : styles['inactive'],
              props.isActive || tabIsActive
                ? activeButtonClassname
                : inactiveButtonClassname,
              styles['tab-button'],
              buttonClassname,
              'no-underline'
            )
          }}
          end
          to={path}
          ref={(navLink) => {
            if (navLink && navLink.classList.contains(styles['active'])) {
              activeLinkRef.current = navLink
            }
          }}
          onClick={() => {
            handleNavLinkClick()
          }}
        >
          {label}
        </NavLink>
      )}
    </>
  )
}

export default TabButton
